import ServicesSeo from "../components/seo/services-seo";
import "./products.css";
export default function Products() {
	return (
		<div className="products-container">
			<ServicesSeo
				description="See what we offer! Quarter, half, or whole lamb processed by local butchers. We also offer 4H and FFA lambs for youth projects and ram service for breeding. "
				services={[
					{
						serviceName: "Quarter Lamb Sales",
						serviceType: "Meat Sales",
						serviceDescription:
							"Purchase pasture-raised lamb by the quarter, processed through a local butcher and available for families in Whatcom County, WA.",
						providerType: "LocalBusiness",
						providerName: "Heron Lane Farm",
						areaServedType: "Place",
						areaServed: "Whatcom County, WA",
					},
					{
						serviceName: "Half Lamb Sales",
						serviceType: "Meat Sales",
						serviceDescription:
							"Half lamb shares available, raised on pasture and processed by trusted local butchers for high-quality, locally sourced meat.",
						providerType: "LocalBusiness",
						providerName: "Heron Lane Farm",
						areaServedType: "Place",
						areaServed: "Whatcom County, WA",
					},
					{
						serviceName: "Whole Lamb Sales",
						serviceType: "Meat Sales",
						serviceDescription:
							"Whole lambs available directly from the farm, pasture-raised and custom processed through local butchers for your family’s freezer.",
						providerType: "LocalBusiness",
						providerName: "Heron Lane Farm",
						areaServedType: "Place",
						areaServed: "Whatcom County, WA",
					},
					{
						serviceName: "4H and FFA Lamb Sales",
						serviceType: "Youth Agriculture Support",
						serviceDescription:
							"Lambs available for 4H and FFA youth projects in Whatcom County, supporting hands-on agricultural education and community events.",
						providerType: "LocalBusiness",
						providerName: "Heron Lane Farm",
						areaServedType: "Place",
						areaServed: "Whatcom County, WA",
					},
					{
						serviceName: "Ram Service",
						serviceType: "Breeding Service",
						serviceDescription:
							"Ram service for local flocks, offering healthy pasture-raised rams for seasonal breeding programs in Whatcom County, WA.",
						providerType: "LocalBusiness",
						providerName: "Heron Lane Farm",
						areaServedType: "Place",
						areaServed: "Whatcom County, WA",
					},
				]}
			/>
			<div className="product-container">
				<img src="/images/lamb2.avif" alt="Lamb" className="product-image" />
				<div className="product-card">
					<h3>Farm Raised Lamb</h3>
					<p>
						Our lambs are born in the spring and raised on pasture with plenty
						of space. We aim to create as low-stress an environment as possible,
						resulting in tender, flavorful meat you can feel good about.
					</p>
					<p>
						Lambs will be brought to a local butcher shop for custom
						slaughtering, cut and wrap.
					</p>
					<a href="/contact" className="cta-button">
						Order Now
					</a>
				</div>
			</div>
			<div className="product-container">
				<div className="product-card">
					<h3>Ram Service</h3>
					<p>
						We offer ram service using our purebred, registered Suffolk ram;
						known for strong genetics, excellent growth rates, and desirable
						meat qualities. Our ram is healthy, well-cared for, and managed with
						biosecurity in mind to help support the health and success of your
						flock
					</p>
					<a href="/contact" className="cta-button">
						Book Now
					</a>
				</div>
				<img src="/images/pearl.avif" alt="Pearl" className="product-image" />
			</div>
			<div className="product-container">
				<img
					src="/images/sheep_grazing.avif"
					alt="Lamb"
					className="product-image"
				/>
				<div className="product-card">
					<h3>4-H or FFA Market Lamb</h3>
					<p>
						We offer Suffolk cross market lambs for 4-H and FFA projects at $250
						each. These lambs come from strong genetics, are well-handled from a
						young age, and grow efficiently; often reaching 120 pounds by
						August! They're a great fit for youth looking for a healthy,
						competitive project animal raised with care.
					</p>
					<a href="/contact" className="cta-button">
						Order Now
					</a>
				</div>
			</div>
		</div>
	);
}
